import { useCallback } from "react";
import api from "../utils/api/axiosInstance";
import { useUserAuth } from "../contexts/UserAuthContext";

/**
 * Unified platform event ingest (match-first spine).
 */
export const usePlatformEvents = () => {
  const { user } = useUserAuth();

  const trackEvent = useCallback(
    async (payload) => {
      if (!user) return null;
      try {
        const res = await api.post("/platform/events", payload);
        return res.data;
      } catch {
        return null;
      }
    },
    [user],
  );

  const trackProduct = useCallback(
    (action, productId, extra = {}) => {
      const typeMap = {
        view: "product.view",
        click: "product.click",
        favorite: "product.favorite",
        compare: "product.compare",
        list: "product.list",
        review: "product.review",
        wizardSelect: "product.wizard_select",
        share: "product.share",
        dismiss: "match.product_dismissed",
      };
      const type = typeMap[action] || `product.${action}`;
      const sessionId =
        extra.sessionId || localStorage.getItem("currentSessionId") || undefined;

      return trackEvent({
        type,
        entityType: "product",
        entityId: productId,
        surface: extra.surface || "unknown",
        sessionId,
        metadata: extra.metadata || extra,
      });
    },
    [trackEvent],
  );

  const trackBatch = useCallback(
    async (events) => {
      if (!user || !Array.isArray(events) || !events.length) return null;
      try {
        const res = await api.post("/platform/events/batch", { events });
        return res.data;
      } catch {
        return null;
      }
    },
    [user],
  );

  return { trackEvent, trackProduct, trackBatch };
};

export default usePlatformEvents;
